
import React from 'react';
import { SearchIcon } from 'lucide-react';
import { motion } from 'framer-motion';

interface FloatingSearchButtonProps {
  onClick: () => void;
}

const FloatingSearchButton: React.FC<FloatingSearchButtonProps> = ({ onClick }) => {
  return (
    <motion.button 
      className="fixed bottom-28 right-5 z-50 shadow-lg rounded-full h-14 w-14
                bg-gradient-to-r from-amber-400 to-amber-500
                hover:from-amber-500 hover:to-amber-600
                border-2 border-amber-300 dark:border-amber-600/50 text-white
                transition-all duration-300
                flex items-center justify-center"
      whileHover={{ 
        scale: 1.05, 
        boxShadow: "0 8px 25px rgba(234, 179, 8, 0.4)" 
      }}
      whileTap={{ scale: 0.95 }}
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ 
        type: "spring", 
        damping: 15, 
        stiffness: 300,
        delay: 0.3 
      }}
      onClick={onClick}
    >
      <SearchIcon className="h-6 w-6" />
      <div className="absolute inset-0 rounded-full bg-white/10 animate-pulse-subtle"></div>
    </motion.button>
  );
};

export default FloatingSearchButton;
